/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Are_You_Sure_You_Want_To_RemovInputs */

const en_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to remove this document?`)
};

const es_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar este documento?`)
};

const fr_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir retirer ce document ?`)
};

const de_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher, dass du dieses Dokument entfernen möchtest?`)
};

const ja_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このドキュメントを削除してもよろしいですか？`)
};

const zh_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要移除该文档吗？`)
};

const ar_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل أنت متأكد من أنك تريد إزالة هذا المستند؟`)
};

const id_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda yakin ingin menghapus dokumen ini?`)
};

const it_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler rimuovere questo documento?`)
};

const ru_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить этот документ?`)
};

const pt_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja remover este documento?`)
};

const ko_are_you_sure_you_want_to_remov = /** @type {(inputs: Are_You_Sure_You_Want_To_RemovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정말로 이 문서를 삭제하시겠습니까?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to remove this document?" |
*
* @param {Are_You_Sure_You_Want_To_RemovInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const are_you_sure_you_want_to_remov = /** @type {((inputs?: Are_You_Sure_You_Want_To_RemovInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Are_You_Sure_You_Want_To_RemovInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_are_you_sure_you_want_to_remov(inputs)
	if (locale === "es") return es_are_you_sure_you_want_to_remov(inputs)
	if (locale === "fr") return fr_are_you_sure_you_want_to_remov(inputs)
	if (locale === "de") return de_are_you_sure_you_want_to_remov(inputs)
	if (locale === "ja") return ja_are_you_sure_you_want_to_remov(inputs)
	if (locale === "zh") return zh_are_you_sure_you_want_to_remov(inputs)
	if (locale === "ar") return ar_are_you_sure_you_want_to_remov(inputs)
	if (locale === "id") return id_are_you_sure_you_want_to_remov(inputs)
	if (locale === "it") return it_are_you_sure_you_want_to_remov(inputs)
	if (locale === "ru") return ru_are_you_sure_you_want_to_remov(inputs)
	if (locale === "pt") return pt_are_you_sure_you_want_to_remov(inputs)
	return ko_are_you_sure_you_want_to_remov(inputs)
});